import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import {
  eqVisibleColumns, volVisibleColumns, refVisibleColumns, eqSort, volSort, refSort,
} from '../../../EditReduxConstant';

export const CLEAR_EDIT_TSUNAMI_EVENT = 'CLEAR_EDIT_TSUNAMI_EVENT';

export const GET_EDIT_TSUNAMI_REQUEST = 'GET_EDIT_TSUNAMI_REQUEST';
export const GET_EDIT_TSUNAMI_SUCCESS = 'GET_EDIT_TSUNAMI_SUCCESS';
export const GET_EDIT_TSUNAMI_FAILURE = 'GET_EDIT_TSUNAMI_FAILURE';

export const UPDATE_EDIT_TSUNAMI_REQUEST = 'UPDATE_EDIT_TSUNAMI_REQUEST';
export const UPDATE_EDIT_TSUNAMI_SUCCESS = 'UPDATE_EDIT_TSUNAMI_SUCCESS';
export const UPDATE_EDIT_TSUNAMI_FAILURE = 'UPDATE_EDIT_TSUNAMI_FAILURE';

export const CREATE_EDIT_TSUNAMI_REQUEST = 'CREATE_EDIT_TSUNAMI_REQUEST';
export const CREATE_EDIT_TSUNAMI_SUCCESS = 'CREATE_EDIT_TSUNAMI_SUCCESS';
export const CREATE_EDIT_TSUNAMI_FAILURE = 'CREATE_EDIT_TSUNAMI_FAILURE';


export const EDIT_TSUNAMI_VOLCANO_REQUEST = 'EDIT_TSUNAMI_VOLCANO_REQUEST';
export const EDIT_TSUNAMI_VOLCANO_SUCCESS = 'EDIT_TSUNAMI_VOLCANO_SUCCESS';
export const EDIT_TSUNAMI_VOLCANO_FAILURE = 'EDIT_TSUNAMI_VOLCANO_FAILURE';

export const EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST = 'EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST';
export const EDIT_TSUNAMI_VOLCANO_SEARCH_SUCCESS = 'EDIT_TSUNAMI_VOLCANO_SEARCH_SUCCESS';
export const EDIT_TSUNAMI_VOLCANO_SEARCH_FAILURE = 'EDIT_TSUNAMI_VOLCANO_SEARCH_FAILURE';

export const EDIT_TSUNAMI_EARTHQUAKE_REQUEST = 'EDIT_TSUNAMI_EARTHQUAKE_REQUEST';
export const EDIT_TSUNAMI_EARTHQUAKE_SUCCESS = 'EDIT_TSUNAMI_EARTHQUAKE_SUCCESS';
export const EDIT_TSUNAMI_EARTHQUAKE_FAILURE = 'EDIT_TSUNAMI_EARTHQUAKE_FAILURE';

export const EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST = 'EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST';
export const EDIT_TSUNAMI_EARTHQUAKE_SEARCH_SUCCESS = 'EDIT_TSUNAMI_EARTHQUAKE_SEARCH_SUCCESS';
export const EDIT_TSUNAMI_EARTHQUAKE_SEARCH_FAILURE = 'EDIT_TSUNAMI_EARTHQUAKE_SEARCH_FAILURE';


export const EDIT_TSUNAMI_REFERENCE_REQUEST = 'EDIT_TSUNAMI_REFERENCE_REQUEST';
export const EDIT_TSUNAMI_REFERENCE_SUCCESS = 'EDIT_TSUNAMI_REFERENCE_SUCCESS';
export const EDIT_TSUNAMI_REFERENCE_FAILURE = 'EDIT_TSUNAMI_REFERENCE_FAILURE';

export const EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST = 'EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST';
export const EDIT_TSUNAMI_REFERENCE_SEARCH_SUCCESS = 'EDIT_TSUNAMI_REFERENCE_SEARCH_SUCCESS';
export const EDIT_TSUNAMI_REFERENCE_SEARCH_FAILURE = 'EDIT_TSUNAMI_REFERENCE_SEARCH_FAILURE';


export const EDIT_TSUNAMI_REGION_REQUEST = 'EDIT_TSUNAMI_REGION_REQUEST';
export const EDIT_TSUNAMI_REGION_SUCCESS = 'EDIT_TSUNAMI_REGION_SUCCESS';
export const EDIT_TSUNAMI_REGION_FAILURE = 'EDIT_TSUNAMI_REGION_FAILURE';


export const EDIT_TSUNAMI_COUNTRY_REQUEST = 'EDIT_TSUNAMI_COUNTRY_REQUEST';
export const EDIT_TSUNAMI_COUNTRY_SUCCESS = 'EDIT_TSUNAMI_COUNTRY_SUCCESS';
export const EDIT_TSUNAMI_COUNTRY_FAILURE = 'EDIT_TSUNAMI_COUNTRY_FAILURE';


export const EDIT_TSUNAMI_AREA_REQUEST = 'EDIT_TSUNAMI_AREA_REQUEST';
export const EDIT_TSUNAMI_AREA_SUCCESS = 'EDIT_TSUNAMI_AREA_SUCCESS';
export const EDIT_TSUNAMI_AREA_FAILURE = 'EDIT_TSUNAMI_AREA_FAILURE';


export const EDIT_TSUNAMI_LOCATION_REQUEST = 'EDIT_TSUNAMI_LOCATION_REQUEST';
export const EDIT_TSUNAMI_LOCATION_SUCCESS = 'EDIT_TSUNAMI_LOCATION_SUCCESS';
export const EDIT_TSUNAMI_LOCATION_FAILURE = 'EDIT_TSUNAMI_LOCATION_FAILURE';


export const EDIT_TSUNAMI_VALIDITY_REQUEST = 'EDIT_TSUNAMI_VALIDITY_REQUEST';
export const EDIT_TSUNAMI_VALIDITY_SUCCESS = 'EDIT_TSUNAMI_VALIDITY_SUCCESS';
export const EDIT_TSUNAMI_VALIDITY_FAILURE = 'EDIT_TSUNAMI_VALIDITY_FAILURE';


export const EDIT_TSUNAMI_CAUSE_REQUEST = 'EDIT_TSUNAMI_CAUSE_REQUEST';
export const EDIT_TSUNAMI_CAUSE_SUCCESS = 'EDIT_TSUNAMI_CAUSE_SUCCESS';
export const EDIT_TSUNAMI_CAUSE_FAILURE = 'EDIT_TSUNAMI_CAUSE_FAILURE';

export const EDIT_TSUNAMI_WARNING_STATUS_REQUEST = 'EDIT_TSUNAMI_WARNING_STATUS_REQUEST';
export const EDIT_TSUNAMI_WARNING_STATUS_SUCCESS = 'EDIT_TSUNAMI_WARNING_STATUS_SUCCESS';
export const EDIT_TSUNAMI_WARNING_STATUS_FAILURE = 'EDIT_TSUNAMI_WARNING_STATUS_FAILURE';


export const EDIT_TSUNAMI_VOLCANO_SORT = 'EDIT_TSUNAMI_VOLCANO_SORT';
export const EDIT_TSUNAMI_EARTHQUAKE_SORT = 'EDIT_TSUNAMI_EARTHQUAKE_SORT';
export const EDIT_TSUNAMI_REFERENCE_SORT = 'EDIT_TSUNAMI_REFERENCE_SORT';

export const EDIT_TSUNAMI_OPEN_CONFIRMATION = 'EDIT_TSUNAMI_OPEN_CONFIRMATION';
export const EDIT_TSUNAMI_CANCEL_CONFIRMATION = 'EDIT_TSUNAMI_CANCEL_CONFIRMATION';

export const EDIT_TSUNAMI_EARTHQUAKE_TOGGLE_COLUMN = 'EDIT_TSUNAMI_EARTHQUAKE_TOGGLE_COLUMN';
export const EDIT_TSUNAMI_REFERENCE_TOGGLE_COLUMN = 'EDIT_TSUNAMI_REFERENCE_TOGGLE_COLUMN';
export const EDIT_TSUNAMI_VOLCANO_TOGGLE_COLUMN = 'EDIT_TSUNAMI_VOLCANO_TOGGLE_COLUMN';

const initialState = fromJS({
  fetched: false,
  tsunami: {
    referenceIds: [],
  },
  updating: false,

  volcano: [],
  fetchedVolcano: false,
  volcanoSearchResults: [],
  volcanoSearching: false,

  earthquake: [],
  fetchedEarthquake: false,
  earthquakeSearchResults: [],
  earthquakeSearching: false,

  references: [],
  fetchedReferences: false,
  referenceSearchResults: [],
  referenceSearching: false,

  fetchedRegions: false,
  regions: [],
  fetchedCountries: false,
  countries: [],
  fetchedAreas: false,
  areas: [],
  fetchedLocations: false,
  locations: [],
  fetchedValidities: false,
  validities: [],
  fetchedCauses: false,
  causes: [],
  fetchedWarningStatuses: false,
  warningStatuses: [],

  volSort,
  eqSort,
  refSort,

  eqVisibleColumns,
  volVisibleColumns,
  refVisibleColumns,

  formData: {},
  editConfirmationOpen: false,

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const editTsunamiEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EDIT_TSUNAMI_EVENT:
      return initialState;

    case EDIT_TSUNAMI_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        editConfirmationOpen: true,
      }));
    case EDIT_TSUNAMI_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        editConfirmationOpen: false,
      }));

    case GET_EDIT_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));
    case CREATE_EDIT_TSUNAMI_REQUEST:
    case UPDATE_EDIT_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetched: false,
        updating: true,
      }));
    case CREATE_EDIT_TSUNAMI_SUCCESS:
    case UPDATE_EDIT_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        tsunami: action.response,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetched: true,
        tsunami: action.response,
        updating: false,
      }));
    case CREATE_EDIT_TSUNAMI_FAILURE:
    case UPDATE_EDIT_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
        formData: {},
        editConfirmationOpen: false,
      }));
    case GET_EDIT_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetched: false,
        updating: false,
      }));

    case EDIT_TSUNAMI_VOLCANO_REQUEST:
      return state.merge(fromJS({
        fetchedVolcano: false,
      }));
    case EDIT_TSUNAMI_VOLCANO_SUCCESS:
      return state.merge(fromJS({
        fetchedVolcano: true,
        volcano: action.response.items,
      }));
    case EDIT_TSUNAMI_VOLCANO_FAILURE:
      return state.merge(fromJS({
        fetchedVolcano: true,
      }));


    case EDIT_TSUNAMI_VOLCANO_SORT:
      return state.merge(fromJS({
        volcanoSearchResults: basicSort(action.sort, state.get('volcanoSearchResults')),
        volSort: action.sort,
      }));

    case EDIT_TSUNAMI_VOLCANO_SEARCH_REQUEST:
      return state.merge(fromJS({
        volcanoSearching: true,
      }));
    case EDIT_TSUNAMI_VOLCANO_SEARCH_SUCCESS:
      return state.merge(fromJS({
        volcanoSearching: false,
        volcanoSearchResults: basicSort(state.get('volSort'), fromJS(action.response.items)),
      }));
    case EDIT_TSUNAMI_VOLCANO_SEARCH_FAILURE:
      return state.merge(fromJS({
        volcanoSearching: false,
      }));


    case EDIT_TSUNAMI_EARTHQUAKE_SORT:
      return state.merge(fromJS({
        earthquakeSearchResults: basicSort(action.sort, state.get('earthquakeSearchResults')),
        eqSort: action.sort,
      }));

    case EDIT_TSUNAMI_EARTHQUAKE_REQUEST:
      return state.merge(fromJS({
        fetchedEarthquake: false,
      }));
    case EDIT_TSUNAMI_EARTHQUAKE_SUCCESS:
      return state.merge(fromJS({
        fetchedEarthquake: true,
        earthquake: action.response.items,
      }));
    case EDIT_TSUNAMI_EARTHQUAKE_FAILURE:
      return state.merge(fromJS({
        fetchedEarthquake: true,
      }));

    case EDIT_TSUNAMI_EARTHQUAKE_SEARCH_REQUEST:
      return state.merge(fromJS({
        earthquakeSearching: true,
      }));
    case EDIT_TSUNAMI_EARTHQUAKE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        earthquakeSearching: false,
        earthquakeSearchResults: basicSort(state.get('eqSort'), fromJS(action.response.items)),
      }));
    case EDIT_TSUNAMI_EARTHQUAKE_SEARCH_FAILURE:
      return state.merge(fromJS({
        earthquakeSearching: false,
      }));


    case EDIT_TSUNAMI_REFERENCE_SORT:
      return state.merge(fromJS({
        referenceSearchResults: basicSort(action.sort, state.get('referenceSearchResults')),
        refSort: action.sort,
      }));

    case EDIT_TSUNAMI_REFERENCE_REQUEST:
      return state.merge(fromJS({
        fetchedReferences: false,
      }));
    case EDIT_TSUNAMI_REFERENCE_SUCCESS:
      return state.merge(fromJS({
        fetchedReferences: true,
        references: action.response.items,
      }));
    case EDIT_TSUNAMI_REFERENCE_FAILURE:
      return state.merge(fromJS({
        fetchedReferences: true,
      }));

    case EDIT_TSUNAMI_REFERENCE_SEARCH_REQUEST:
      return state.merge(fromJS({
        referenceSearching: true,
      }));
    case EDIT_TSUNAMI_REFERENCE_SEARCH_SUCCESS:
      return state.merge(fromJS({
        referenceSearching: false,
        referenceSearchResults: basicSort(state.get('refSort'), fromJS(action.response.items)),
      }));
    case EDIT_TSUNAMI_REFERENCE_SEARCH_FAILURE:
      return state.merge(fromJS({
        referenceSearching: false,
      }));


    case EDIT_TSUNAMI_REGION_REQUEST:
      return state.merge(fromJS({
        fetchedRegions: false,
      }));
    case EDIT_TSUNAMI_REGION_SUCCESS:
      return state.merge(fromJS({
        fetchedRegions: true,
        regions: action.response.items,
      }));
    case EDIT_TSUNAMI_REGION_FAILURE:
      return state.merge(fromJS({
        fetchedRegions: true,
      }));

    case EDIT_TSUNAMI_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case EDIT_TSUNAMI_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case EDIT_TSUNAMI_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case EDIT_TSUNAMI_AREA_REQUEST:
      return state.merge(fromJS({
        fetchedAreas: false,
      }));
    case EDIT_TSUNAMI_AREA_SUCCESS:
      return state.merge(fromJS({
        fetchedAreas: true,
        areas: action.response.items,
      }));
    case EDIT_TSUNAMI_AREA_FAILURE:
      return state.merge(fromJS({
        fetchedAreas: true,
      }));

    case EDIT_TSUNAMI_LOCATION_REQUEST:
      return state.merge(fromJS({
        fetchedLocations: false,
      }));
    case EDIT_TSUNAMI_LOCATION_SUCCESS:
      return state.merge(fromJS({
        fetchedLocations: true,
        locations: action.response.items,
      }));
    case EDIT_TSUNAMI_LOCATION_FAILURE:
      return state.merge(fromJS({
        fetchedLocations: true,
      }));


    case EDIT_TSUNAMI_VALIDITY_REQUEST:
      return state.merge(fromJS({
        fetchedValidities: false,
      }));
    case EDIT_TSUNAMI_VALIDITY_SUCCESS:
      return state.merge(fromJS({
        fetchedValidities: true,
        validities: action.response.items,
      }));
    case EDIT_TSUNAMI_VALIDITY_FAILURE:
      return state.merge(fromJS({
        fetchedValidities: true,
      }));


    case EDIT_TSUNAMI_CAUSE_REQUEST:
      return state.merge(fromJS({
        fetchedCauses: false,
      }));
    case EDIT_TSUNAMI_CAUSE_SUCCESS:
      return state.merge(fromJS({
        fetchedCauses: true,
        causes: action.response.items,
      }));
    case EDIT_TSUNAMI_CAUSE_FAILURE:
      return state.merge(fromJS({
        fetchedCauses: true,
      }));

    case EDIT_TSUNAMI_WARNING_STATUS_REQUEST:
      return state.merge(fromJS({
        fetchedWarningStatuses: false,
      }));
    case EDIT_TSUNAMI_WARNING_STATUS_SUCCESS:
      return state.merge(fromJS({
        fetchedWarningStatuses: true,
        warningStatuses: action.response.items,
      }));
    case EDIT_TSUNAMI_WARNING_STATUS_FAILURE:
      return state.merge(fromJS({
        fetchedWarningStatuses: true,
      }));

    case EDIT_TSUNAMI_EARTHQUAKE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        eqVisibleColumns: action.visibleColumns,
      }));

    case EDIT_TSUNAMI_REFERENCE_TOGGLE_COLUMN:
      return state.merge(fromJS({
        refVisibleColumns: action.visibleColumns,
      }));

    case EDIT_TSUNAMI_VOLCANO_TOGGLE_COLUMN:
      return state.merge(fromJS({
        volVisibleColumns: action.visibleColumns,
      }));

    default:
      return state;
  }
};
